import { http } from '../../config/axios'

export default function getMotorCredito(): Promise<any[]> {
  return http
    .get('api/motorcredito')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getMotorCredito', error)
      throw Error(error.response.data)
    })
}
